import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Actions from '../../actions';
import OrderList from '../../components/order/list';
import OrdersAPI from '../../apis/order';
import APP_ROUTES from '../../constants/app-routes';

const mapStateToProps = (state, ownProps) => ({
    orders: state.orderList.orders,
    pageCount: state.orderList.totalPages,
    user: state.user,
    access_token: state.auth.access_token,
    stores: state.stores.stores,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({
    loadOrders: (userAPIToken, pageNum, locale) => {
        dispatch(Actions.displayLoader());
        const params = {};
        params.page_no = pageNum;
        params.locale = locale.currentLocale;

        return OrdersAPI.mine(userAPIToken, params).then((response) => {
            const { data: fetchedOrders, meta } = response.body;

            if (pageNum > 1) {
                fetchedOrders.forEach((order) => {
                    dispatch(Actions.addOrder(order, meta));
                });
            } else {
                dispatch(Actions.addOrders(fetchedOrders, meta));
            }
            dispatch(Actions.hideLoader());
        });
    },

    handleUserNotLoggedIn: () => {
        dispatch(push(APP_ROUTES.homePageRoute));
        // dispatch(Actions.showFlash('Please Sign in to view your orders'));
    },
});

const OrderListConnector = connect(mapStateToProps, mapDispatchToProps)(OrderList);

export default OrderListConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/order/list-connector.js
 **/